import "core-js/modules/es.string.link";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import weixin from '@tencent/vft-common/weixin';
import tenvideo from '@tencent/vft-common/tenvideo';
import env from '@tencent/vft-common/env';
import util from '@tencent/vft-common/util';

function tenvideoOn(event, callback) {
  tenvideo.tenvideoReady(function () {
    TenvideoJSBridge.on(event, function (res) {
      var data;

      if (typeof res == 'string') {
        try {
          data = JSON.parse(res);
        } catch (e) {}
      } else if (_typeof(res) == 'object') {
        data = res;
      }

      callback(data);
    });
  });
}

var DEFAULT_PROMPT_IMG = '//vm.gtimg.cn/tencentvideo/vstyle/mobile/vip/style/app_v2/img/common/g_share_spm.png?d=0317&max_age=31104000';
var shareState = {
  show: false,
  promptImg: DEFAULT_PROMPT_IMG
};
export default {
  data: function data() {
    return shareState;
  },
  methods: {
    hide: function hide() {
      shareState.show = false;
      shareState._cancel && shareState._cancel();
    },
    open: function open() {
      shareState.show = true;
    },
    close: function close() {
      shareState.show = false;
    }
  },
  install: function install(Vue) {
    /**
     * 设置分享内容。
     * 注意
     * 1、success回调和cancel回调只在腾讯视频APP、微信、手Q内有效，存在一定可接受范围内的误差。
     * 2、ipad腾讯视频APP内暂无正确的回调
     * @param shareParams {imgUrl,title,desc,link,success,cancel}
     */
    function setShare(shareParams) {
      shareState.promptImg = shareParams.promptImg || DEFAULT_PROMPT_IMG;
      shareState._success = shareParams.success;

      shareParams.success = function (res) {
        shareState.show = false;
        shareState._success && shareState._success(res);
      };

      shareState._cancel = shareParams.cancel;

      shareParams.cancel = function (res) {
        shareState.show = false;
        shareState._cancel && shareState._cancel(res);
      };

      shareState.shareParams = shareParams;

      if (weixin.isWeiXin()) {
        weixin.setShare(shareParams);
      } else if (tenvideo.isTenvideo()) {
        tenvideo.setShare(shareParams);
        tenvideoOn('onShareFinish', function (data) {
          if (data && data.errCode == 0 && data.errMsg !== 'share canceled') {
            if (typeof data == "string") {
              data = JSON.parse(data);
            }

            var type = data.result && data.result.type;
            shareParams.success({
              app: 'app',
              shareTo: type
            });
          } else {
            shareParams.cancel(data);
          }
        });
      } else if (env.isMqq) {
        util.loadScript("mqq-sdk", "//open.mobile.qq.com/sdk/qqapi.js?_bid=152", function () {
          mqq.data.setShareInfo({
            title: shareParams.title,
            desc: shareParams.desc,
            share_url: shareParams.link,
            image_url: shareParams.imgUrl
          });
          mqq.ui.setOnShareHandler(function (type) {
            var shareParams = shareState.shareParams;
            mqq.ui.shareMessage({
              share_type: type,
              title: shareParams.title,
              desc: shareParams.desc,
              share_url: shareParams.link,
              image_url: shareParams.imgUrl,
              sourceName: '腾讯视频VIP',
              back: true
            }, function (result) {
              if (result && result.retCode === 0) {
                var res = {
                  app: 'qq',
                  shareTo: type
                };
                shareParams.success(res);
              } else {
                shareParams.cancel();
              }
            });
          });
          mqq.ui.setWebViewBehavior({
            actionButton: 1
          }); //隐藏底部导航条：

          mqq.ui.setWebViewBehavior({
            bottomBar: false
          });
        });
      }
    }

    function goShare() {
      if (weixin.isWeiXin()) {
        shareState.show = true;
      } else if (env.isIpad && env.isApp) {
        tenvideo.tenvideoReady(function () {
          TenvideoJSBridge.invoke("shareTo", {
            "webShareID": "23333",
            "webShareTitle": shareState.shareParams.title,
            "webShareSubTitle": shareState.shareParams.desc,
            "webShareImageURL": shareState.shareParams.imgUrl,
            "webShareURL": shareState.shareParams.link,
            "useCustomeInfo": true
          }, function (json_msg) {//                            console.log(json_msg)
          });
        });
      } else if (tenvideo.isTenvideo()) {
        tenvideo.openShare();
      } else if (env.isMqq) {
        mqq.ui.showShareMenu();
      } else {
        shareState.show = true;
      }
    }

    function clickShare(shareParams) {
      setShare(shareParams);
      goShare();
    }

    return Vue.prototype.share = {
      setShare: setShare,
      goShare: goShare,
      clickShare: clickShare,
      hasSuccessCallBack: env.isMqq || env.isApp || env.isWechat
    };
  }
};